<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Expansão nacional</h2>
          <p>
            A compra de uma unidade em Planaltina (DF) representa a
            <strong>expansão do processamento de 100 para 300</strong> animais
            por dia, permitindo a ampliação das vendas para as Regiões Sul e
            Sudeste do País.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/1980/1980-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1984/02/19/g/19840219-33425-nac-0152-fem-13-not-qgsasgh.jpg'
              )
            "
          />
          <img
            src="../assets/img/1980/1980-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1982/12/19/g/19821219-33062-nac-0067-999-67-not-gpkgkqe.jpg'
              )
            "
          />
          <img
            src="../assets/img/1980/1980-3.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1986/10/08/g/19861008-34236-nac-0080-agr-8-not-aqwkegh.jpg'
              )
            "
          />
          <img
            src="../assets/img/1980/1980-4.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1981/10/08/g/19811008-32692-nac-0001-999-1-not-wagxkge.jpg'
              )
            "
          />
          <img
            src="../assets/img/1980/1980-5.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1983/08/21/g/19830821-33270-nac-0046-999-46-not-qkhqpge.jpg'
              )
            "
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>A chegada do freezer e impulso nas exportações</h2>
          <p>
            Ao longo dos anos 1970, o processo de industrialização e urbanização
            do Brasil avançou consideravelmente – naquela década, a população
            urbana superou a população rural, aumentando a demanda por acesso a
            alimentos nas grandes cidades. Novos eletrodomésticos, como o
            <strong>freezer</strong>, ajudavam quem precisava se alimentar
            trazendo o consumo de congelados para dentro de casa e abrindo novas
            oportunidades para a indústria.
          </p>
          <p>
            Foi criada a
            <strong
              >Associação Brasileira das Indústrias Exportadoras de Carne
              (Abiec)</strong
            >, em 1979. Os efeitos puderam ser sentidos rapidamente: em 1981, o
            País se tornou líder na exportação de carne em conserva. Em 1983, já
            mirava a vice-liderança quando o assunto era exportação de carne em
            geral.
          </p>
          <p>
            A Embrapa produz o <strong>capim braquiarão</strong>, uma evolução
            da braquiária que aumentou a produtividade da pecuária nacional.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 140px;
    display: grid;
    grid-template-columns: 396px 323px 1fr;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
      margin: 0 20px;
    }
  }
  &__warpper {
    position: relative;
    &__item {
      padding: 120px 50px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding-left: 0;
      @include media("<=desktop") {
        padding: 0px 20px 40px;
      }
      &--image {
        position: relative;
        background: color(cWhite);
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        @include media("<=desktop") {
          padding: 30px 0;
        }
        &::after {
          content: "";
          background: color(cBLue6);
          position: absolute;
          width: 100%;
          height: 50%;
          top: -140px;
          left: 0;
          z-index: 1;
          @include media("<=desktop") {
            top: 0;
            left: -20px;
            height: 100%;
            width: 100vw;
            background: color(cWhite);
          }
        }
        img {
          display: block;
          cursor: pointer;
          transition: 0.3s ease-in-out;
          position: relative;
          z-index: 2;
          &:hover {
            transform: scale(1.1);
          }

          &:nth-child(2) {
            position: absolute;
            top: 125px;
            right: 70px;
          }
          &:nth-child(4) {
            margin: 0 auto;
          }
          &:nth-child(5) {
            margin: 0 auto;
          }
        }
        span {
          position: absolute;
          right: -55px;
          top: 400px;
          width: 65px;
          color: color(primary);
          strong {
            color: color(primary);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBLue6);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      &::before {
        content: "";
        background: color(cBlue4);
        position: absolute;
        width: 42%;
        bottom: 0;
        left: 0;
        height: 60%;
        opacity: 0.9;
        @include media("<=desktop") {
          width: 100%;
          top: 0;
        }
      }
      &::after {
        content: "";
        background: url(../assets/img/1980/1980-fundo.jpg);
        width: 42%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        background-repeat: no-repeat;
        background-size: cover;
        @include media("<=desktop") {
          width: 100%;
        }
      }
      h2 {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 2.8125rem;
        font-style: normal;
        font-weight: 700;
        position: relative;
        z-index: 2;
      }
      p {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150.5%;
        margin-top: 2rem;
        position: relative;
        z-index: 2;
      }

      &--black {
        margin-left: 1.6rem;
        padding-top: 10px;
        @include media(">desktop") {
          margin-left: 75px;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%; /* 1.4rem */
          text-transform: uppercase;
          margin-bottom: 20px;

          @include media("<=desktop") {
            color: color(cWhite);
            margin-top: 30px;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 150.5%;
          margin-bottom: 20px;
          @include media("<=desktop") {
            color: color(cWhite);
          }
        }

        blockquote {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 2.1875rem;
          font-style: normal;
          font-weight: 700;
          line-height: 106.5%;
          text-align: right;
          max-width: 14rem;
          margin: 0.6rem 0;
          margin-left: auto;
        }
      }
    }
  }
}
</style>
